export default {"src":"/_next/static/media/hyperlink.7c514477.svg","height":16,"width":16};